import { makeStyles, Typography } from 'beam'
import { ReactElement } from 'react'

const useStyles = makeStyles(theme => ({
  displayedValue: {
    fontWeight: 'bold',
    marginTop: theme.spacing(0.5),
  },
}))

export interface SubmissionValueDisplayProps {
  /** Name of displayed value */
  name: string,
  /** Displayed value */
  children: string,
}

export function SubmissionValueDisplay({ name, children }: SubmissionValueDisplayProps): ReactElement {
  const classes = useStyles()
  return (
    <div>
      <Typography variant="subtitle1">{name}</Typography>
      <Typography variant="body1" className={classes.displayedValue}>{children}</Typography>
    </div>
  )
}
